import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import QualityDeliverablesPage from "@/pages/admin/QualityDeliverablesPage";

export const Route = createFileRoute("/_admin/admin/quality-deliverables")({
  head: () => pageHead("Admin · Quality Deliverables", "AKIVA admin · quality deliverables portal.", "/admin/quality-deliverables", true),
  component: QualityDeliverablesPage,
});
